import { makeStyles } from '@mui/styles'
import { DESKTOP_FONT_SIZE } from '@v4/constants/pages'

const useStyles = makeStyles(
	theme => ({
		root: {
			top: 0,
			left: 0,
			bottom: 0,
			right: 0,
			[theme.breakpoints.down('md')]: {
				top: ({ offset: { top } = {} }) => (top ? theme.spacing(top / 18) : 0),

				bottom: ({ offset: { bottom } = {} }) => (bottom ? theme.spacing(bottom / 18) : 0),
			},
			[theme.breakpoints.up('md')]: {
				top: ({ offset: { top } = {} }) => (top ? theme.spacing(top / 10) : 0),

				bottom: ({ offset: { bottom } = {} }) => (bottom ? theme.spacing(bottom / 10) : 0),
			},
			position: 'absolute',
			border: ({ isGlobalSection }) =>
				`2px solid ${isGlobalSection ? theme.palette.scoreapp.alternate : theme.palette.scoreapp.primary}`,
			zIndex: 11,
			pointerEvents: 'none',
		},
		groupButton: {
			position: 'absolute',
			right: theme.spacing(2),
			top: theme.spacing(2),
		},
		container: {
			position: 'absolute',
			left: theme.spacing(2),
			top: theme.spacing(2),
			display: 'flex',
			alignItems: 'center',
			margin: theme.spacing(0.4),
		},
		title: {
			display: 'flex',
			alignItems: 'center',
			lineHeight: 'normal',
			height: theme.spacing(3.25),
			border: `1px ${theme.palette.scoreapp.border} solid`,
			backgroundColor: theme.palette.scoreapp.background,
			borderRadius: 4,
			color: theme.palette.scoreapp.text,
			fontSize: DESKTOP_FONT_SIZE.subtitle2,
			padding: theme.spacing(0.2, 1),
			boxShadow: '0 2px 4px rgba(0, 0, 0, 0.06)',
			fontWeight: 500,
			fontFamily: 'Instrument Sans',
		},
		tierSelector: {
			marginLeft: theme.spacing(2),
			[theme.breakpoints.down('md')]: {
				marginLeft: theme.spacing(0.7),
			},
		},
		actionButton: {
			border: `1px ${theme.palette.scoreapp.border} solid`,
			width: theme.spacing(3.25),
			height: theme.spacing(3.25),
			backgroundColor: theme.palette.scoreapp.background,
			borderRadius: theme.spacing(0.5),
			margin: theme.spacing(0.4),
			color: theme.palette.scoreapp.text,
			minWidth: 0,
			pointerEvents: 'all',
			padding: 0,
			'&:hover': {
				backgroundColor: theme.palette.scoreapp.background,
			},
		},
		greenHover: {
			'&:hover': {
				color: theme.palette.scoreapp.primary,
				borderColor: theme.palette.scoreapp.primary,
			},
		},
		redHover: {
			'&:hover': {
				borderColor: theme.palette.scoreapp.secondary,
				color: theme.palette.scoreapp.secondary,
			},
		},
	}),
	{ name: 'SectionAction' },
)

export default useStyles
